import React from 'react'
import BannerFive from './bannerFive'
import CruiseType from './cruiseType'
import FaqFive from './faqFive'
import FeaturedCruise from './featuredCruise'
import PopularFive from './popularFive'
import FooterFive from './footerFive'

const HomeFive = () => {
  return (
    <>
    <BannerFive/>
    <CruiseType/>
    <PopularFive/>
    <FeaturedCruise/>
    <FaqFive/>
    <FooterFive/>
    </>
  )
}

export default HomeFive